import { createAction } from '@reduxjs/toolkit'

/**
 * Clears the entire Redux store/
 */
export const clearStore = createAction('CLEAR_STORE')
